import styles from './Feature.module.scss';
import AppImage1 from '../../assets/images/feature4_1.png';
import AppImage2 from '../../assets/images/feature4_2.png';
import AppImage3 from '../../assets/images/feature4_3.png';
import AppImage4 from '../../assets/images/feature4_4.png';
import useMobile from '../../hooks/useMobile';
import Slider from 'react-slick';

const Feature4 = () => {
  const { isMobile } = useMobile();

  if (isMobile)
    return (
      <div className={styles.mobile_wrapper}>
        <div className={styles.text_container}>
          <div className={styles.title}>간단한 시작, 특별한 하루</div>
          <div className={styles.description}>
            앱을 다운로드하고 캐릭터를 설정하는 데는
            <br />
            단 몇 분이면 충분해요.
            <br />
            그리고 그 캐릭터는 당신만의 이야기를
            <br />
            오래도록 함께 만들어갈 친구가 되어줄 거예요.
          </div>
        </div>
        <div className={styles.img_container}>
          <div className={styles.slider_container}>
            <Slider
              {...{
                infinite: true,
                speed: 500,
                slidesToShow: 1,
                slidesToScroll: 1,
                centerMode: true,
                centerPadding: '70px',
              }}
            >
              <img src={AppImage1} alt="app" className={styles.app4} />
              <img src={AppImage2} alt="app" className={styles.app4} />
              <img src={AppImage3} alt="app" className={styles.app4} />
              <img src={AppImage4} alt="app" className={styles.app4} />
            </Slider>
          </div>
        </div>
      </div>
    );

  return (
    <div className={styles.wrapper}>
      <div
        className={styles.container}
        style={{
          width: '100%',
        }}
      >
        <div className={styles.title}>간단한 시작, 특별한 하루</div>
        <div className={styles.description}>
          앱을 다운로드하고 캐릭터를 설정하는 데는 단 몇 분이면 충분해요. <br />
          그리고 그 캐릭터는 당신만의 이야기를 오래도록 함께 만들어갈 친구가
          되어줄 거예요.
        </div>
        <div className={styles.app_image_container}>
          <img src={AppImage1} alt="app" className={styles.app4} />
          <img src={AppImage2} alt="app" className={styles.app4} />
          <img src={AppImage3} alt="app" className={styles.app4} />
          <img src={AppImage4} alt="app" className={styles.app4} />
        </div>
      </div>

      <div
        className={styles.topper}
        style={{
          bottom: 0,
        }}
      ></div>
    </div>
  );
};

export default Feature4;
